import type {
  CreateRequestMutation,
  CreateRequestMutationVariables,
} from '@/api/generated/graphql';
import { CREATE_REQUEST_MUTATION } from '@/api/mutations/request';
import { useAuthedClient } from '@/api/useAuthedClient';
import type { CreateRequestInput } from '@/types/request';

import { useGraphQLMutation } from './useGraphQLMutation';

interface UseCreateRequestReturn {
  createRequest: (input: CreateRequestInput) => Promise<{ id: string } | null>;
  isSubmitting: boolean;
  error: Error | null;
}

export function useCreateRequest(): UseCreateRequestReturn {
  const authedClient = useAuthedClient();
  const { mutate, isSubmitting, error } = useGraphQLMutation<
    CreateRequestInput,
    { id: string }
  >({
    mutationFn: async (input, signal) => {
      const response = await authedClient.request<
        CreateRequestMutation,
        CreateRequestMutationVariables
      >({
        document: CREATE_REQUEST_MUTATION,
        variables: { input },
        signal,
      });
      return response.createRequest;
    },
  });

  return { createRequest: mutate, isSubmitting, error };
}
